import { Component, Inject } from '@angular/core';
import { MatSnackBar, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { GaleriaService } from '../../../../providers/galeria.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Imagen } from '../../../../interfaces/imagen';
import { FileHolder } from '../../../../components/archivos/image-upload/image-upload.component';

@Component({
  selector: 'app-subir-imagenes-galeria-dialog',
  templateUrl: './subir-imagenes-galeria-dialog.component.html',
  styleUrls: ['./subir-imagenes-galeria-dialog.component.scss']
})
export class SubirImagenesGaleriaDialog {
  imagenes: Imagen[] = <Imagen[]>[];
  imageUploadEstados = [];
  imageUploadProgressValue: number;
  imageUploadProgressLimit: number;
  cargandoImagenes: boolean = false;

  constructor(
    public dialogCrear: MatDialogRef<SubirImagenesGaleriaDialog>,
    private galeriaService: GaleriaService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
    private _sanitizer: DomSanitizer
  ) { }

  onInput(): void {
    this.imageUploadEstados = [];
  }

  onFinalizar(): void {
    this.dialogCrear.close();
  }

  getSecureUrl(url) {
    return this._sanitizer.bypassSecurityTrustStyle(`url(${url})`);
  }

  onImagenCargada(fileHolder: FileHolder): void {
    this.imagenes.push(<Imagen>{
      src: fileHolder.src,
      nombre: fileHolder.file.name
    });
  }

  onImagenQuitada(fileHolder: FileHolder) {
    this.imagenes.forEach((imagen: Imagen, index: number) => {
      if (imagen.nombre == fileHolder.file.name && imagen.src == fileHolder.src) {
        this.imagenes.splice(index, 1);
      }
    });
  }

  onSubirArchivos(): void {
    this.cargandoImagenes = true;

    // Subir imágenes
    this.imageUploadEstados = [];
    this.imageUploadProgressValue = 0;
    this.imageUploadProgressLimit = this.imagenes.length;
    if (this.imagenes.length > 0) {
      this.enviarImagenAlSv(this.imagenes[0]);
    } else {
      this.cargandoImagenes = false;
    }
  }

  enviarImagenAlSv(imagen: Imagen): void {
    this.galeriaService.guardarFotosGaleria(
      [imagen]
    ).subscribe(
      respuesta => {
        if (respuesta) {
          this.imageUploadEstados.push({
            nombre: imagen.nombre,
            estado: respuesta.estado,
            mensaje: respuesta.mensaje,
            src: imagen.src
          });
        }

        this.imagenEnviada();
      },
      error => {
        this.imageUploadEstados.push({
          nombre: imagen.nombre,
          estado: 2,
          mensaje: error,
          src: imagen.src
        });
        this.imagenEnviada();
      }
    );
  }

  imagenEnviada(): void {
    this.imagenes.splice(0, 1);
    if (this.imagenes.length > 0) {
      this.imageUploadProgressValue = 100 * (this.imageUploadProgressLimit - this.imagenes.length) / this.imageUploadProgressLimit;
      this.enviarImagenAlSv(this.imagenes[0]);
    } else {
      this.cargandoImagenes = false;
    }
  }
}
